console.log('hi');

function checkAndRemoveWidget() {
  console.log('Checking for widget...');

  const widElement = document.querySelector('#shopify-block-AUjZ1eTZteEVuS2J0K__judge_me_reviews_review_widget_htcEdg #judgeme_product_reviews');

  if (widElement) {
    console.log('Widget element found.');
    const widStyle = widElement.style.display;
    console.log(widStyle)

    if (widStyle === 'none') {
      console.log('Widget is hidden, removing parent block.');
      const container = document.querySelector('#shopify-section-template--15550164762677__1741806654973097a9 .container');
      if(container){
        container.remove();
      }
    } else {
      console.log('Widget is visible, no removal needed.');
    }
  } else {
    console.log('Widget element not found yet. Retrying...');
    setTimeout(checkAndRemoveWidget, 200); // Retry after 200ms
  }
}

function runAfterLoad() {
  if (document.readyState === 'complete') {
    console.log('Document loaded, starting widget check.');
    checkAndRemoveWidget();
  } else {
    window.addEventListener('load', function() {
      console.log('Window loaded, starting widget check.');
      checkAndRemoveWidget();
    });
  }
}

runAfterLoad();